
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getStaticContactProps } from 'components/pages/overview/contact-us/people/[id]';
import { ISR_REVALIDATE_TIME } from 'lib/constants';
import { GetStaticPaths, GetStaticProps, GetStaticPropsResult } from 'next';
import ContentView, { _getDynamicPage, ContentViewProps } from 'pages/[...slug]';
import React from 'react';
import { getSubpageComponent, getSubpageProps } from 'utils/getOverviewPage';
type OverviewPageProps = {
    pageProps: any;
};
export default function OverviewPage({ pageProps, model }: OverviewPageProps & ContentViewProps): JSX.Element {
    if (model)
        return <ContentView model={model}/>;
    const OverviewPageComponent = getSubpageComponent('contactUsUrl', undefined, 'contact');
    return <>{OverviewPageComponent && React.createElement(OverviewPageComponent as any, { ...pageProps })}</>;
}
export const getStaticPaths: GetStaticPaths = () => {
    return {
        paths: [],
        fallback: true,
    };
};
const getStaticProps: GetStaticProps<OverviewPageProps | ContentViewProps> = async (ctx): Promise<GetStaticPropsResult<OverviewPageProps | ContentViewProps>> => {
    const { id } = ctx.params as {
        id: string;
    };
    const languageCodename = ctx.locale ?? process.env.NEXT_PUBLIC_DEFAULT_LOCALE!;
    const pageProps = await getSubpageProps('contactUsUrl', languageCodename, id, 'contact');
    if (!(pageProps as Awaited<ReturnType<typeof getStaticContactProps>>).person) {
        return await _getDynamicPage(ctx);
    }
    return {
        props: {
            pageProps,
        },
        revalidate: ISR_REVALIDATE_TIME,
    };
};

    async function __Next_Translate__getStaticProps__1a0e785469b__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[mainSubpage]/[subcategory]/[id]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0e785469b__ as getStaticProps }
  